<template>
  <div class="search-engine">
    <DetailPage :default-value="inputValue" v-if="detailPage"></DetailPage>
    <div class="search-area" v-else>
      <el-input
        placeholder="请输入内容"
        suffix-icon="el-icon-search"
        v-model="inputValue"
        @keyup.enter.native="swtichPage"
        @input="searchFocus"
      >
      </el-input>
      <div class="smart-tips" v-if="smartTips">
        <div class="smartInformations" v-for="(item, index) in smartTipsInformation" :key="index" :label="item" :value="index"
        @click="smartClick(item)">
            {{item}}
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import DetailPage from "@/views/Search/DetailPage";
import api from "@/services/api";
export default {
  components: {
    DetailPage,
  },
  data() {
    return {
      inputValue: "",
      detailPage: false,
      smartTips:false,
      smartTipsInformation:[]
    };
  },
  methods: {
    swtichPage() {
      this.smartTips = false;
      this.detailPage = true;
    },
    searchFocus(){
      this.smartTips = true;
      const params = {
        keywords:this.inputValue+""
      }
      api.region_information.search_prompt("",{params}) .response.then((res) => res.data)
      .then((res) => {
        if(res.code == 200){
          this.smartTipsInformation = res.data.prompt_message
        }
      })
    },
    // 点击赋值之后查询
    smartClick(value){
      this.inputValue = value
      this.swtichPage()
    }
  },
};
</script>

<style lang="scss">
$fontColor: #eee;
.search-engine {
  height: calc(90vh - 55px);

  & > .search-area {
    height: 100%;
    padding: 0 30vw;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    & .el-input {
      margin: 10px;
      .el-input__inner {
        color: $fontColor;
        background-color: transparent;
        border-radius: 15px;
      }
    }
  }
}
.smart-tips{
  width: 100%;
  height: 40vh;
  background-color:rgb(255,255,255,0.2);
  z-index: 3;
  margin: 0 10px;
  overflow: auto;
}
.smartInformations{
  display: flex;
  justify-content:space-between;
  height: 3vh;
  line-height: 3vh;
  font-size: 13px;
  text-overflow :ellipsis; 
  white-space :nowrap; 
  overflow : hidden;
}
.smartInformations:hover{
  cursor: pointer;
  color: orange;
  background-color:rgb(255,255,255,0.2)
}
</style>
